class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onStandardEventsReady = () => {
      if (this.viewEventRequested) return this.dispatchCartViewEvent();
    };
    this.viewEventRequested = false;
    this.viewEventDispatched = false;
    this.viewEventPending = false;
    this.viewEventRequestToken = 0;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  connectedCallback() {
    document.addEventListener('shopify:standard-events:ready', this.onStandardEventsReady);
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:standard-events:ready', this.onStandardEventsReady);
    this.viewEventRequested = false;
    this.viewEventPending = false;
    this.viewEventRequestToken += 1;
  }

  open() {
    const wasOpen = this.notification.classList.contains('active');
    if (!wasOpen) {
      this.viewEventRequested = true;
      this.viewEventDispatched = false;
      this.viewEventPending = false;
      this.viewEventRequestToken += 1;
    }

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
    this.dispatchCartViewEvent();
  }

  async dispatchCartViewEvent() {
    if (!this.viewEventRequested || this.viewEventDispatched || this.viewEventPending) return;

    const { CartViewEvent } = window.StandardEvents || {};
    if (!CartViewEvent) return;

    const requestToken = this.viewEventRequestToken;
    this.viewEventPending = true;
    try {
      const response = await fetch(`${routes.cart_url}.json`);
      if (!response.ok) return;
      const cart = await response.json();
      if (!cart?.currency || !this.viewEventRequested || requestToken !== this.viewEventRequestToken) return;

      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart: CartViewEvent.createCartFromAjaxResponse(cart),
        }),
      );
      this.viewEventDispatched = true;
    } catch {
      // Cart view events are informational and must not block the notification.
    } finally {
      if (requestToken === this.viewEventRequestToken) this.viewEventPending = false;
    }
  }

  close() {
    this.notification.classList.remove('active');
    this.viewEventRequested = false;
    this.viewEventPending = false;
    this.viewEventRequestToken += 1;
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
